const MARQUEE_ITEMS = [
  "Private Curation",
  "Heritage Stays",
  "Slow Travel",
  "Cultural Audiences",
  "Conservation First",
  "Bespoke Itineraries",
];

export default function MarqueeSection() {
  return (
    <section className="relative bg-ivory border-y border-line-light py-8 overflow-hidden">
      <div className="flex whitespace-nowrap animate-marquee">
        {[...Array(2)].flatMap((_, i) =>
          MARQUEE_ITEMS.map((t) => (
            <span
              key={`${i}-${t}`}
              className="font-serif italic text-3xl md:text-4xl px-10 text-ink/40"
            >
              {t} <span className="text-indigo_deep/70 text-base md:text-lg mx-3 align-middle">✦</span>
            </span>
          ))
        )}
      </div>
    </section>
  );
}
